/* sugar:assets/card-media.js@2.1.7 */
/*
 * Product card photo row — on phones a card's photos are a CSS scroll-snap row (Carousel, or
 * Swipe to the second photo on phones). This only moves the dots under the row as it is swiped.
 * Delegated from the document (scroll is caught in the capture phase), so cards from the filter
 * refetch or load more need no wiring.
 */
(function () {
  'use strict';

  if (window.SugarCardMedia) return;

  var pending = null;

  function sync(track) {
    var width = track.clientWidth;
    if (!width) return;
    var index = Math.round(track.scrollLeft / width);
    var dots = track.closest('[data-card-slides]').querySelectorAll('.sugar-card__dot');
    Array.prototype.forEach.call(dots, function (dot, i) {
      var on = i === index;
      if (dot.classList.contains('is-active') !== on) dot.classList.toggle('is-active', on);
    });
  }

  document.addEventListener(
    'scroll',
    function (event) {
      var track = event.target;
      if (!track.classList || !track.classList.contains('sugar-card__track')) return;
      if (pending === track) return;
      pending = track;
      requestAnimationFrame(function () {
        pending = null;
        sync(track);
      });
    },
    true
  );

  window.SugarCardMedia = { sync: sync };
})();
